import { RetailPartnerStoreInfoResp } from 'domain/payload/response/retailPartner/RetailPartnerResp';
import React from 'react';

interface MerchantPartnerStoreInfoCardProps {
  storeInfo: RetailPartnerStoreInfoResp[];
}

const MerchantPartnerStoreInfoCard: React.FC<MerchantPartnerStoreInfoCardProps> = ({ storeInfo }) => {
  const hasStoreInfo = storeInfo && storeInfo.length > 0;

  const openInGoogleMaps = (latitude: number | null, longitude: number | null, storeName: string) => {
    if (latitude && longitude) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
    }
  };

  return (
    <div className="card h-100 border">
      <div className="card-header bg-light border-bottom">
        <h6 className="mb-0 fw-bold">Store Information</h6>
      </div>
      <div className="card-body" style={{ maxHeight: '450px', overflowY: 'auto' }}>
        {hasStoreInfo ? (
          <div className="accordion" id="storeAccordion">
            {storeInfo.map((store, index) => (
              <div className="accordion-item border mb-2" key={store.id}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0 ? 'true' : 'false'}
                    aria-controls={`collapse${index}`}
                  >
                    <strong>{store.storeName}</strong>
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#storeAccordion"
                >
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="d-flex align-items-start">
                          <div className="me-3 text-muted">
                            <i className="fa-solid fa-map-marker-alt"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-muted small mb-1">Address</div>
                            <div className="fw-medium">{store.address || 'N/A'}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex align-items-start">
                          <div className="me-3 text-muted">
                            <i className="fa-solid fa-landmark"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-muted small mb-1">Landmark</div>
                            <div className="fw-medium">{store.landmark || 'N/A'}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <div className="me-3 text-muted">
                            <i className="fa-solid fa-store"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-muted small mb-1">Store Type</div>
                            <div className="fw-medium">{store.storeTypeName || 'N/A'}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <div className="me-3 text-muted">
                            <i className="fa-solid fa-road"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-muted small mb-1">Road Type</div>
                            <div className="fw-medium">{store.roadTypeName || 'N/A'}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <div className="me-3 text-muted">
                            <i className="fa-solid fa-calendar"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-muted small mb-1">Years in Operation</div>
                            <div className="fw-medium">{store.yearsInOperation || 'N/A'}</div>
                          </div>
                        </div>
                      </div>

                      {store.latitude && store.longitude && (
                        <div className="col-12">
                          <div className="d-flex align-items-start">
                            <div className="me-3 text-muted">
                              <i className="fa-solid fa-location-dot"></i>
                            </div>
                            <div className="flex-grow-1">
                              <div className="text-muted small mb-1">Coordinates</div>
                              <div 
                                className="fw-medium text-primary cursor-pointer"
                                onClick={() => openInGoogleMaps(store.latitude, store.longitude, store.storeName)}
                                style={{ cursor: 'pointer' }}
                                title="Click to open in Google Maps"
                              >
                                {store.latitude.toFixed(6)}, {store.longitude.toFixed(6)}
                                <i className="fa-solid fa-external-link-alt ms-2"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-3">
            <i className="fa-solid fa-store text-muted fa-3x mb-2"></i>
            <p className="text-muted">No store information available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchantPartnerStoreInfoCard;